import Pageable from "@/entities/pageable/pageable_collection";
import { TransactionDeletion } from "@/entities/transaction-deletion";

export interface TransactionDeletionService {
  fetchTransactionDeletions(map: Record<string, unknown>): Promise<Pageable<TransactionDeletion>>;
  downloadDetailsById(transactionDeletionId: string): Promise<File>;
  downloadTemplate(): Promise<File>;
  isUserAllowed(): Promise<{ allowed: boolean }>;
  uploadDeletionFile(formData: FormData): Promise<void>;
}

export interface TransactionDeletionServiceMock {
  fetchTransactionDeletions: jest.Mock<Promise<Pageable<TransactionDeletion>>>;
  downloadDetailsById: jest.Mock<Promise<File>>;
  downloadTemplate: jest.Mock<Promise<File>>;
  isUserAllowed: jest.Mock<Promise<{ allowed: boolean }>>;
  uploadDeletionFile: jest.Mock<Promise<void>>;
}

export interface ITransactionDeletionFilter {
  text?: string;
  status?: string;
  startDate: Date;
  endDate: Date;
}

export const iniTransactionDeletionFilter: ITransactionDeletionFilter = {
  text: "",
  status: "",
  startDate: new Date(new Date().setHours(0, 0, 0, 0)),
  endDate: new Date(new Date().setHours(23, 59, 59, 999)),
};


